import React from "react";

// Import all SVGs
import ArrowRightIcon from "./icons/arrow-right-icon.svg";
import CheckIcon from "./icons/check-icon.svg";
import CloseIcon from "./icons/close-icon.svg";
import EmailIcon from "./icons/email-icon.svg";
import GearIcon from "./icons/gear-icon.svg";
import ListIcon from "./icons/list-icon.svg";
import PrintIcon from "./icons/print-icon.svg";
import QuestionIcon from "./icons/question-icon.svg";
import ResetIcon from "./icons/reset-icon.svg";
import RotateClockwiseIcon from "./icons/rotate-clockwise-icon.svg";
import RotateCounterClockwiseIcon from "./icons/rotate-counter-clockwise-icon.svg";
import SearchIcon from "./icons/search-icon.svg";
import ShareIcon from "./icons/share-icon.svg";
import UndoIcon from "./icons/undo-icon.svg";

// Map icons to their respective components
const icons = {
  "arrow-right": ArrowRightIcon,
  check: CheckIcon,
  close: CloseIcon,
  email: EmailIcon,
  gear: GearIcon,
  list: ListIcon,
  print: PrintIcon,
  question: QuestionIcon,
  reset: ResetIcon,
  "rotate-clockwise": RotateClockwiseIcon,
  "rotate-counter-clockwise": RotateCounterClockwiseIcon,
  search: SearchIcon,
  share: ShareIcon,
  undo: UndoIcon,
};

const SVGIcon = ({ icon }) => {
  let iconFile = icons[icon];

  let style = {};

  if (icon === "arrow-left") {
    style = {
      transform: "rotate(180deg)",
    };
    iconFile = icons["arrow-right"];
  }

  if (!iconFile) {
    console.warn(`Icon "${icon}" not found.`);
    return null;
  }

  return <img src={iconFile} alt={icon} style={style} />;
};

export default SVGIcon;
